import { tooltipTiggerVariables, tooltipContentVariables, windowProperties } from "./tooltipVariables.js";

//=====================================================================
// Position the popover content block
//=====================================================================
export function tooltipPositoning(trigger, tooltip, tooltipClasses) {

    // Get the required variables
    const { windowScrollPosition, windowHeight, windowWidth } = windowProperties();
    const { triggerFromTop, triggerFromTopPlusScroll, triggerFromLeft, triggerWidth, triggerHeight  } = tooltipTiggerVariables(trigger, windowScrollPosition);
    const { tooltipWidthHalf,  tooltipHeight, tooltipWidth } = tooltipContentVariables(tooltip, windowScrollPosition);

    //=====================================================================
    // Calculate the position variables
    //=====================================================================

    // Default variables
    let tooltipClassHorizontal = null;
    let tooltipClassVertical = tooltipClasses.above;
    let positionTooltipTop = triggerFromTopPlusScroll - tooltipHeight;
    let positionTooltipLeft = triggerFromLeft - tooltipWidthHalf + triggerWidth;

    // Check the trigger/content position
    const contentNearTop = triggerFromTop < windowHeight - triggerFromTop - triggerHeight;
    const contentNearLeft = positionTooltipLeft < tooltip.getBoundingClientRect().left;
    const contentNearRight = positionTooltipLeft > (windowWidth - tooltip.getBoundingClientRect().right);


   // Position The Tooltip and add classes
   if (contentNearTop) {
       positionTooltipTop = triggerFromTopPlusScroll - tooltipHeight + tooltipHeight + triggerHeight;
       tooltipClassVertical = tooltipClasses.below;
   }
   if (contentNearLeft) {
       positionTooltipLeft = triggerFromLeft;
       tooltipClassHorizontal = tooltipClasses.left;
   }
   if (contentNearRight) {
       positionTooltipLeft = triggerFromLeft - tooltipWidth + (triggerWidth * 2);
       tooltipClassHorizontal = tooltipClasses.right;
   }

    //console.log(trigger)
    const additionalClass = trigger.getAttribute('data-tooltipClassVariable');

    // Filter out classes from the last hover/Click
    Array.from(tooltip.classList)
        .filter(className => className !== "cTooltip")
        .forEach(className => tooltip.classList.remove(className));
    tooltip.classList.add(tooltipClassVertical);
    if (additionalClass) tooltip.classList.add(additionalClass);
    if (tooltipClassHorizontal !== null) tooltip.classList.add(tooltipClassHorizontal);

    return {
        tooltipPositionTop: positionTooltipTop,
        tooltipPositionLeft: positionTooltipLeft,
    }
}